import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 2% 4%;
  color: var(--grey);
  width: 100%;
`;
const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export { Wrapper, CardWrapper };
